import React from 'react';
import { theme } from '../../../../shared/lib/styles';

const TrueFalseQuestion = ({ question, onAnswer, answered, selectedValue }) => {
    const handleSelect = (value) => {
        if (answered) return;
        onAnswer(value === question.correct, value);
    };

    const blocks = [
        { label: 'Правда', value: true, color: theme.colors.parchmentLight },
        { label: 'Неправда', value: false, color: theme.colors.parchmentDark },
    ];

    return (
        <div style={styles.row}>
            {blocks.map(({ label, value, color }) => {
                let outline = theme.colors.ink;
                if (answered) {
                    if (value === question.correct) outline = theme.colors.success;
                    else if (value === selectedValue) outline = theme.colors.danger;
                }
                return (
                    <button
                        key={label}
                        type="button"
                        disabled={answered}
                        onClick={() => handleSelect(value)}
                        style={{
                            ...styles.block,
                            backgroundColor: color,
                            color: theme.colors.ink,
                            boxShadow:
                                answered && (value === question.correct || value === selectedValue)
                                    ? `0 0 0 3px ${outline}`
                                    : 'none',
                        }}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
};

const styles = {
    row: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing.lg,
    },
    block: {
        padding: theme.spacing.xxl,
        fontSize: theme.fontSize['2xl'],
        fontWeight: theme.fontWeight.bold,
        border: `2px solid ${theme.colors.ink}`,
        borderRadius: theme.borderRadius.xl,
        cursor: 'pointer',
    },
};

export default TrueFalseQuestion;
